import { render, staticRenderFns } from "./CashGoodsWait.vue?vue&type=template&id=2391f6d0&"
import script from "./CashGoodsWait.vue?vue&type=script&lang=js&"
export * from "./CashGoodsWait.vue?vue&type=script&lang=js&"
import style0 from "./CashGoodsWait.vue?vue&type=style&index=0&id=2391f6d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports